import paths from "@ingka/icons-shared/paths/arrow-left";
import { renderPaths } from "../renderPaths.mjs";
var arrow_left_default = () => renderPaths(paths);
export {
  arrow_left_default as default
};
